"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refresh = refresh;
exports.createCompany = createCompany;
exports.deleteCompany = deleteCompany;
exports.updateCompanies = updateCompanies;
exports.updateCompany = updateCompany;
exports.updateCompanyProperties = updateCompanyProperties;
exports.fetchByDomain = fetchByDomain;
exports.removeDomain = removeDomain;

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _transact = require("crm_data/flux/transact");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var CompaniesAPI = _interopRequireWildcard(require("crm_data/companies/api/CompaniesAPI"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _AssociationTypes = require("crm_data/associations/AssociationTypes");

var toPropertyList = function toPropertyList(record) {
  return record.get('properties').reduce(function (list, _ref, name) {
    var value = _ref.value,
        source = _ref.source,
        sourceId = _ref.sourceId;
    return list.push({
      value: value,
      name: name,
      sourceId: sourceId,
      source: source
    });
  }, (0, _immutable.List)());
};

var makeAssociationKey = function makeAssociationKey(id, associationType) {
  return (0, _immutable.Map)({
    objectId: id,
    objectType: _ObjectTypes.COMPANY,
    associationType: associationType
  });
};

function refresh(ids) {
  (0, _Dispatch.dispatchQueue)(_ActionTypes.COMPANIES_REFRESH_QUEUED, (0, _immutable.Set)(ids));
  (0, _Dispatch.dispatchQueue)(_ActionTypes.ASSOCIATIONS_REFRESH_QUEUED, (0, _immutable.Set)([makeAssociationKey(ids[0], _AssociationTypes.COMPANY_TO_CONTACT), makeAssociationKey(ids[0], _AssociationTypes.COMPANY_TO_DEAL), makeAssociationKey(ids[0], _AssociationTypes.COMPANY_TO_TICKET)]));
}

function createCompany(record) {
  var properties = toPropertyList(record);
  return CompaniesAPI.createCompany(properties).then(function (response) {
    var company = response.first();
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANY_CREATED, company);
    return company;
  });
}

function deleteCompany(companyId, callback) {
  return CompaniesAPI.deleteCompany(companyId).then(function () {
    setTimeout(function () {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANIES_UPDATED, (0, _immutable.Map)().set("" + companyId, null));
    }, 0);
    return typeof callback === 'function' ? callback() : undefined;
  }).done();
}

function updateCompanies(companies) {
  (0, _invariant.default)(_immutable.Map.isMap(companies), 'Companies Actions: expected companies to be a Map but got "%s"');
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANIES_UPDATED, companies);
}

function updateCompany(company, updates) {
  var companyId = company.get('companyId');
  return (0, _transact.transact)({
    operation: function operation() {
      return CompaniesAPI.update((0, _immutable.Map)({
        companyId: companyId,
        properties: updates
      }));
    },
    commit: [_ActionTypes.COMPANIES_UPDATED, (0, _immutable.Map)().set(companyId, updates.reduce(function (updated, property) {
      return updated.setIn(['properties', property.get('name'), 'value'], property.get('value'));
    }, company))],
    rollback: [_ActionTypes.COMPANIES_UPDATED, company]
  });
}

function updateCompanyProperties(company, nextProperties) {
  var id = "" + company.get('companyId');
  var properties = nextProperties.map(function (_, name) {
    return (0, _ImmutableModel.getProperty)(company, name);
  });
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANIES_UPDATE_STARTED, {
    id: id,
    properties: properties,
    nextProperties: nextProperties
  });
  return CompaniesAPI.updateCompanyProperties(company, nextProperties).then(function () {
    return (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANIES_UPDATE_SUCCEEDED, {
      id: id,
      properties: nextProperties,
      prevProperties: properties
    });
  }, function (error) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANIES_UPDATE_FAILED, {
      error: error,
      id: id,
      nextProperties: nextProperties,
      properties: properties
    });
    throw error;
  });
}

function fetchByDomain(domain) {
  return CompaniesAPI.fetchByDomain(domain).then(function (companies) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANIES_FETCH_SUCCEEDED, companies);
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANY_DOMAIN_FOUND, {
      domain: domain,
      companies: companies
    });
  }, function () {
    return (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANY_DOMAIN_NOT_FOUND, {
      domain: domain
    });
  }).done();
}

function removeDomain(subject, domain) {
  return CompaniesAPI.removeDomain(subject, domain).then(function () {
    return (0, _Dispatch.dispatchImmediate)(_ActionTypes.COMPANY_DOMAIN_REMOVED, {
      domain: domain,
      company: subject
    });
  });
}